export default __webpack_public_path__ + "static/media/loading-dark.c447eb8a.gif";